import { useTranslation } from "react-i18next";
import { useEffect, useMemo, useState } from "react";
import { ExternalLinkButton, FormAutocomplete, RowInfo } from "../common";
import { Col, Row } from "../App.styles";
import { PaymentTeamsModal } from "./modals";
import theme from "../themes";

const Paid = ({ useQuery }) => {
  const { t } = useTranslation()
  const [collection] = useQuery();
  const cost = updateCosts(collection);
  const { purchased_players } = collection;
  const [value, setValue] = useState('');
  const [disabled, setDisabled] = useState(false);
  const [teamQuantities, setTeamQuantities] = useState([
    1,
    2,
    3,
    4,
    5,
    10,
    15,
    20,
    50,
    100,
    250,
    500,
    1000,
    10000,
    100000,
    1000000,
  ])
  const teamsOptions = useMemo(() => {
    
    return teamQuantities
      .sort((a, b) => a - b)
      .map(i => ({ id: i, name: String(i), disabled: ![1].includes(i) }))
  }, [
    teamQuantities,
  ])

  useEffect(() => {
    if (!teamQuantities.includes(purchased_players)) {
      const list = [...teamQuantities]
      list.push(purchased_players)
      setTeamQuantities(list)
      setDisabled(true)
    }
    setValue(purchased_players)
  }, [purchased_players, setTeamQuantities, teamQuantities])

  return (
    <>
      <RowInfo help={<PaymentTeamsModal />}>
        <div className="form-outline">
          <FormAutocomplete
            label={t('Teams')}
            value={value}
            stateful={false}
            size="small"
            options={teamsOptions}
            disabled={disabled}
            key={value}
            creatable
          />
        </div>
      </RowInfo>
      <Row>
        <Col size="10">
          <label className="form-label">Cost</label>${cost} USD
        </Col>
        <Col size="2">
          <ExternalLinkButton
            color="success"
            href={theme.contactURL}
            target="_blank"
          >
            Paid
          </ExternalLinkButton>
        </Col>
      </Row>
    </>
  );
};

export default Paid;

const updateCosts = ({ license_type, purchased_players = 1 }) => {
  const maxdays = 1;
  let rate;

  switch (parseInt(license_type)) {
    default:
      rate = 30.0;
      break;
    case 2:
      rate = 10.0;
      break;
    case 3:
      rate = 15.0;
      break;
    case 4:
      rate = 20.0;
      break;
  }

  if (parseInt(purchased_players) === 1) {
    return 0;
  }

  return (parseFloat(purchased_players) * rate * parseFloat(maxdays)).toFixed(
    2
  );
};
